import React from "react";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import UniversalLineChartComponent from "../../../../Universal/UniversalLineChartComponent";

const LineGraphChart = ({ graphData }) => {
  return (
    <div className="expensesLineChartComponent">
      <div className="graphHeader">
        <h3>Fees Collection</h3>
        <SelectFilter />
      </div>
      <div className="graphContent">
        <UniversalLineChartComponent
          data={graphData.lineChartData}
          lines={[
            {
              dataKey: "fees",
              name: "Fees",
              stroke: "#FF9D00",
            },
          ]}
          xAxisKey="name"
          referenceLinesStep={1000}
        />
      </div>
    </div>
  );
};

export default LineGraphChart;
